import * as React from 'react';

import * as Sentry from '@sentry/browser';

import {
  GasV3Integration,
  SentryBrowserIntegration,
} from '@atlassian/commerce-ui/telemetry-integrations';

import { CartAnalyticsClient } from 'modules/analytics';

export const CommerceSharedComponentIntegrations: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <GasV3Integration client={CartAnalyticsClient.getInternalClient()}>
      <SentryBrowserIntegration client={Sentry}>{children}</SentryBrowserIntegration>
    </GasV3Integration>
  );
};
